import { isEmpty, memoize } from 'lodash';
import store from './store';

export const applyDocumentClasses = () => {
  let classes = [];

  if (store.state.brand) {
    classes.push(store.state.brand.identifier);
  }

  classes = classes.filter((v: string): boolean => !isEmpty(v));

  const html = document.querySelector('html');

  if (html) {
    html.classList.add(...classes);
  }
};

export const attemptReboot = (hours: number): void => {
  const now = new Date();

  if (now.getMinutes() !== 0) {
    return;
  }

  if (now.getHours() % hours !== 0) {
    return;
  }

  store.dispatch('reboot');
};

/**
 * Convert the iframe injection jsonp-style callback into a Promise-based, await-able
 * function. Memoize the Promise from the initial call so that when it resolves
 * once, later app launches will reuse the resolved promise.
 */
const getKioskProId = memoize(() =>
  Promise.race([
    new Promise(resolve => {
      if (window.kioskpro_hooks_available !== 1) {
        console.warn(
          'The Kiosk Pro functions have not been loaded. The kiosk id could not be fetched for GA tracking.'
        );

        resolve(null);

        return;
      }

      window.kp_requestKioskId_callback = (kioskId: string) => {
        console.info('Kiosk Pro responded with id: ', kioskId);
        resolve(isEmpty(kioskId) ? null : kioskId);
      };

      try {
        window.kp_requestKioskId('kp_requestKioskId_callback');
      } catch (error) {
        console.warn(
          'Could not fetch Kiosk Pro unique id. Is the app running outside of Kiosk Pro?'
        );
        resolve(null);
      }
    }),
    new Promise(resolve =>
      setTimeout(() => {
        console.info('KioskPro failed to respond. Moving on...');
        resolve(null);
      }, 2000)
    ),
  ])
);

export const trackAppLaunch = async (
  appName: string,
  storeNumber: number,
  storeName: string,
  groupName: string,
  kioskId: string
) => {
  const kioskProId = await getKioskProId();

  console.info('Tracking App Launch: ', {
    appName,
    storeNumber,
    storeName,
    groupName,
    kioskProId,
    kioskId,
  });

  if (window.ga === undefined) {
    console.info('GA tracking skipped - no GA token has been set');
    return;
  }

  window.ga('gtm1.send', 'event', 'Kiosk App', 'launched', appName, {
    dimension1: storeNumber, // store number
    dimension2: storeName, // store name
    dimension3: groupName, // group name (member name)
    dimension4: isEmpty(kioskProId) ? 'unset' : kioskProId, // kiosk pro uniq id
    dimension5: kioskId, // deli & more kiosk account id
  });
};

export const inject3rdPartyScript = (url: string | null) => {
  const id = 'js-injected-script';
  const $existing = document.querySelector(`#${id}`);

  if ($existing && $existing.parentNode) {
    $existing.parentNode.removeChild($existing);
  }

  if (!url) {
    return;
  }

  const $script = document.createElement('script');
  $script.type = 'text/javascript';
  $script.src = url;
  $script.setAttribute('id', id);

  document.body.appendChild($script);
};
